export const decisioningStudioAgentsAppGroupId = "/decisioning_studio_agents/:app_group_id";
